import React from 'react'
import { Link } from 'gatsby'

const Tag = ({ to = null, href = null, style = 'default', size = 'default', children }) => {
  const styles = {
    default: 'bg-white border-gray-900',
    defaultSelected: 'bg-black border-gray-900 text-white',
    gray: 'bg-gray-50 border-gray-100',
    blue: 'border-blue-700 bg-blue-600 text-white',
    black: 'bg-black border-gray-900 text-white',
    blackOutline: 'bg-white border-black',
  }

  const sizes = {
    sm: 'py-0.5 px-2',
    default: 'py-1.5 px-4',
    lg: 'py-2 px-5',
  }

  const className = `border rounded mb-3 mr-1.5 sm:mr-3 last:mr-0 ${sizes[size]} ${styles[style]}`

  if (to) {
    return (
      <Link to={to} className={className}>
        {children}
      </Link>
    )
  } else if (href) {
    return (
      <a href={href} target="_blank" className={className}>
        {children}
      </a>
    )
  }

  return <div className={className}>{children}</div>
}

export default Tag
